const defaults = {
  notesList: {
    __typename: 'NotesList',
    compositionIds: [],
    patientNoteIds: []
  }
}

const resolvers = {
  Mutation: {
    setNotesList: (_, { compositionIds, patientNoteIds }, { cache }) => {
      const data = {
        notesList: {
          __typename: 'NotesList',
          compositionIds: compositionIds || [],
          patientNoteIds: patientNoteIds || []
        }
      }
      cache.writeData({ data })
      return null
    }
  }
}

export default {
  defaults,
  resolvers
}
